module.exports = __webpack_public_path__ + "img/js.91edad0.png";